import React,{useState,useMemo,useEffect} from 'react';
import Sidebar from "./Sidebar";
import MaterialReactTable from 'material-react-table';
import { useSelector, useDispatch } from "react-redux";
import { Link,useParams,useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
import { clearErrors, getAllOrders, deleteOrder } from "../../actions/orderAction";
import Loader from "../Loader";
import { Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MetaData from '../../components/MetaData.js';
import { DELETE_ORDER_RESET  } from "../../constants/orderConstant";

const OrderList = () => {

	const dispatch = useDispatch();
	// const {id} = useParams();
	const alert = useAlert();
	const navigate = useNavigate();
	const { loading, error, orders } = useSelector((state) => state.allOrders);

	const { error: deleteError, isDeleted } = useSelector((state) => state.order);

	const deleteOrderHandler = (id) => {
		// console.log('ok');
	    dispatch(deleteOrder(id));
	};

	useEffect(() => {
		if (error) {
		  alert.error(error);
		  dispatch(clearErrors());
		}

		if (deleteError) {
		  alert.error(deleteError);
		  dispatch(clearErrors());
		}

		if (isDeleted) {
		  alert.success("Order Deleted Successfully");
		  // navigate("/admin/dashboard");
		  dispatch({ type: DELETE_ORDER_RESET  });
		}

		dispatch(getAllOrders());
	}, [dispatch, alert, error, deleteError, isDeleted, navigate]);

	const [currencySymbol, setCurrencySymbol] = useState("£");
  const [countryCode, setCountryCode] = useState("GB");
  const [isLoading, setIsLoading] = useState(false);

  // Country-to-Currency mapping with exchange rates
  const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    // Fetch user's country using their IP address
    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

    const fetchExchangeRates = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error("Failed to fetch exchange rates");
        const data = await response.json();

        setCountryToCurrency((prev) => {
          const updatedCurrencies = { ...prev };

          Object.keys(updatedCurrencies).forEach((country) => {
            const currencyCode = updatedCurrencies[country].currencyCode;
            const rate = data.rates[currencyCode];
            if (rate) {
              updatedCurrencies[country].rate = rate;
            }
          });

          return updatedCurrencies;
        });
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    };

    // Fetch user's country using their IP address
    const fetchUserCountry = async () => {
    try {
      const response = await fetch("https://get.geojs.io/v1/ip/country.json");
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      return data.country || "GB";
    } catch (error) {
      console.error("Error fetching user country:", error);
      return "GB"; // Default to GB on failure
    }
  };


    const loadCurrencyDetails = async () => {
    setIsLoading(true);
    await fetchExchangeRates();
    const userCountry = await fetchUserCountry();
    setCountryCode(userCountry);
    // Use updated rates
  setCountryToCurrency((prev) => {
    const currencyInfo = prev[userCountry] || prev["GB"]; // Default to GBP if country not found
    setCurrencySymbol(currencyInfo.symbol || "£");
    return prev;
  });
    setIsLoading(false);
  };

  useEffect(() => {
    loadCurrencyDetails();
  }, []);

	const columns = useMemo(
	    () => [
	      {
	        accessorFn: (row) => row._id, //alternate way
	        id: 'id', //id required if you use accessorFn instead of accessorKey
	        header: 'Id',
	        Header: () => <span>Id</span>, //optional custom header render
	      },
	      {
	        accessorFn: (row) => <span className={row.orderStatus === "Delivered" ? "text-success" : "text-danger"}>{row.orderStatus}</span>, //alternate way
	        id: 'status', //id required if you use accessorFn instead of accessorKey
	        header: 'Status',
	        Header: () => <span>Status</span>, //optional custom header render
	      },
	      {
	        accessorFn: (row) => <span>{row.orderItems.length}</span>, //alternate way
	        id: 'itemsQty', //id required if you use accessorFn instead of accessorKey
	        header: 'Items Qty',
	        Header: () => <span>Items Qty</span>, //optional custom header render
	      },
	      {
	        accessorFn: (row) => <span>£{row.totalPrice}</span>, //alternate way
	        id: 'amount', //id required if you use accessorFn instead of accessorKey
	        header: 'Amount',
	        Header: () => <span>Amount</span>, //optional custom header render
	      },	      
	      {
	        accessorFn: (row) => <span>
	                            <Link to={`/admin/order-process/${row._id}`}>
	                              <EditIcon />
	                            </Link>
	                            <Button onClick={() => deleteOrderHandler(row._id)}>
	                              <DeleteIcon />
	                            </Button>
	                          </span>, //alternate way
	        id: 'action', //id required if you use accessorFn instead of accessorKey
	        header: 'Action',
	        Header: () => <span>Action</span>, //optional custom header render
	      },
	    ],
	    [],
	);

	return (
		<>
			{loading ? (
        <Loader />
      ) : (
      	<>

		      		<div className="dashboard-panel">
					<div className="container">
						<MetaData title={`ALL ORDERS - Admin`} />
						<div className="row">
							<Sidebar />	
							<div className="col-lg-9 col-md-8">
								<div className="dashboardContainer">
							        <h3>All Orders</h3>
							        <div className="col-12">
		                    			<MaterialReactTable columns={columns} data={orders} enableRowNumbers rowNumberMode="original"/>
		  						    </div>
							    </div>
							</div>
						</div>
					</div>
					</div>
</>
		)}
		      	
		</>
	)
}

export default OrderList